import { render, staticRenderFns } from "./freightCompensationStatistical.vue?vue&type=template&id=39be4aeb&scoped=true"
import script from "./freightCompensationStatistical.vue?vue&type=script&lang=ts"
export * from "./freightCompensationStatistical.vue?vue&type=script&lang=ts"
import style0 from "./freightCompensationStatistical.vue?vue&type=style&index=0&id=39be4aeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be4aeb",
  null
  
)

export default component.exports